import { useState } from 'react';
import Fade from '../Fade';
import FilterMenu from './FilterMenu';
import { useIntl } from 'react-intl';

const FilterSelector = (props) => {
  const intl = useIntl();
  const { filters = [], defaultAlignment } = props;
  const [hide, setHide] = useState(true);
  const handleShowHide = () => {
    setHide(!hide);
  };
  return (
    <div className="drs-container">
      <div>
        <button
          data-testid="filtersMenu"
          className="filter-bar-header filter-bar-header--clickable"
          onClick={handleShowHide}
        >
          <i className="uil uil-filter"></i>
          <span className="desktop-label">{intl.formatMessage({ id: 'filters' })}</span>
        </button>
        <Fade hide={hide}>
          <FilterMenu
            filters={filters}
            handleShowHide={handleShowHide}
            additionalOptions={props.additionalOptions}
            removeItems={props.removeItems}
            defaultAlignment={defaultAlignment}
          />
        </Fade>
      </div>
    </div>
  );
};

FilterSelector.defaultProps = {
  disabled: false,
  isLoading: false,
};

export default FilterSelector;
